import { LocalPizza } from '@mui/icons-material'
import FoodUpsellingList from './FoodUpsellingList'
import FoodUpsellingEdit from './FoodUpsellingEdit'
import FoodUpsellingCreate from './FoodUpsellingCreate'

const foodUpsellingIndex = {
  icon: LocalPizza,
  list: FoodUpsellingList,
  edit: FoodUpsellingEdit,
  create: FoodUpsellingCreate,
}

export default foodUpsellingIndex
